import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";

import { getAuthors } from "../../utils/utils";

const AuthorsView = ({ story }) => {
  const authorList = getAuthors(story);

  return (
    <React.Fragment>
      {authorList.map((author, index) => (
        <Link key={index} href={author.slug}>
          {author.name}
        </Link>
      ))}
    </React.Fragment>
  );
};

AuthorsView.propTypes = {
  story: object.isRequired,
};

export default AuthorsView;
